import { render, staticRenderFns } from "./LottoList.vue?vue&type=template&id=753f34be&"
import script from "./LottoList.vue?vue&type=script&lang=js&"
export * from "./LottoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports